/** Read catalog user fields from JWT (superadmin / support global session). */
export function getUserFromToken() {
  try {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return {
      id: payload.sub || payload.id || null,
      username: payload.username || null,
      role: payload.role || null,
    };
  } catch {
    return null;
  }
}

export function getUserIdFromToken() {
  return getUserFromToken()?.id ?? null;
}
